var React = require('react');

function ArrowInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M198 368V236.47C198 236.47 218.56 236.47 242.62 236.47C265.91 235.72 271.14 226.82 259.62 206.47C223.44 142.78 186.67 79.4698 150.02 16.0198C138.02 -4.81017 128.2 -3.17036 117.17 15.5696C80.0502 78.703 43.3269 142.04 7.0002 205.58C-5.4698 227.4 -0.259802 236.32 25.0002 236.32C49.8202 236.32 68.1802 236.51 68.1802 236.51C68.1802 236.51 68.0002 323 68.0002 368H198Z","fill":"#143673"}));
}

ArrowInline.defaultProps = {"width":"266","height":"368","viewBox":"0 0 266 368","fill":"none"};

module.exports = ArrowInline;

ArrowInline.default = ArrowInline;
